import React from "react";
import CollapsibleSection from "../../../common/CollapsibleSection.jsx";
import ToggleSwitch from "../../../common/ToggleSwitch.jsx";
import styles from './ToggleableSection.module.scss';
import get from 'lodash/get';
import TooltipWithRef from "../../../common/Tooltip.jsx";

export const DEFAULT_ENABLED_KEY = 'enabled'

export const getInitialCollapsed = (selectedObject, prefix, enabledKey = DEFAULT_ENABLED_KEY) => {
  return !get(selectedObject, prefix)?.[enabledKey];
}

function ToggleableSection({ prefix, title, selectedObject, setAttribute, initialCollapsed = true, children, enabledKey = DEFAULT_ENABLED_KEY, collapseHeadingSize, defaultValue }) {
  const value = get(selectedObject, prefix)?.[enabledKey];
  const enabled = defaultValue !== undefined ? value ?? defaultValue : !!value; // fall back only when defaultValue is set
  return (
    <CollapsibleSection
      title={title} initialCollapsed={initialCollapsed} collapseHeadingSize={collapseHeadingSize}
      buttons={
        <TooltipWithRef title={I18n.t('collapse_section_toggle_tooltip')} trigger='hover'>
          <ToggleSwitch size='sm' name={`${prefix}-toggle-${Math.random()}`} className={styles['toggle-collapsible-section']} 
                        isOn={enabled} handleToggle={() => setAttribute(`${prefix}.${enabledKey}`, !enabled)}
          />
        </TooltipWithRef>
      }
    >
      {children}
    </CollapsibleSection>
  );
}


export default ToggleableSection;